import React, { useEffect, useState } from 'react';
import './AffiliateDealsSection.css';

const AffiliateDealsSection = () => {
  const [deals, setDeals] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [form, setForm] = useState({
    title: '',
    description: '',
    price: '',
    originalPrice: '',
    discountPercent: '',
    image: '',
    affiliate_link: '',
  });
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch('https://discountdost.com/api/link-deals')
      .then((res) => res.json())
      .then((data) => setDeals(data))
      .catch((err) => console.error('Error fetching affiliate deals:', err));
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAutoFill = async () => {
    try {
      const response = await fetch('https://discountdost.com/api/fetch-affiliate-details', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ affiliate_link: form.affiliate_link }),
      });

      const data = await response.json();
      if (response.ok) {
        setForm((prev) => ({
          ...prev,
          ...data,
        }));
        setMessage('Auto-filled successfully!');
      } else {
        setMessage(data.error || 'Auto-fill failed.');
      }
    } catch (error) {
      console.error(error);
      setMessage('Error during auto-fill.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('affiliate_link', form.affiliate_link);
    formData.append('title', form.title);
    formData.append('description', form.description);
    formData.append('price', form.price);
    formData.append('originalPrice', form.originalPrice);
    formData.append('discountPercent', form.discountPercent);

    if (imageFile) {
      formData.append('image', imageFile);
    }

    try {
      const response = await fetch('https://discountdost.com/api/manual-add-affiliate-deal', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();
      if (response.ok) {
        setMessage('Deal submitted successfully!');
        setDeals([...deals, { ...form, _id: Date.now(), image: URL.createObjectURL(imageFile) }]);
        setForm({
          title: '',
          description: '',
          price: '',
          originalPrice: '',
          discountPercent: '',
          affiliate_link: ''
        });
        setImageFile(null);
        setShowForm(false);
      } else {
        setMessage(data.error || 'Submission failed.');
      }
    } catch (error) {
      console.error(error);
      setMessage('Error submitting deal.');
    }
  };

  return (
    <section className="affiliate-deals-wrapper">
      <h2 className="affiliate-heading">Premium Deals</h2>
        <div className="add-deal-wrapper">
          <button className="add-deal-button" onClick={() => setShowForm(true)}>
            New Deals
          </button>
        </div>

      {showForm && (
        <div className="affiliate-form-modal">
          <form onSubmit={handleSubmit} className="affiliate-form" encType="multipart/form-data">
            <label>Affiliate Link:
              <input type="text" name="affiliate_link" value={form.affiliate_link} onChange={handleChange} required />
              <button type="button" onClick={handleAutoFill}>Auto-Fill</button>
            </label>

            <label>Title:
              <input type="text" name="title" value={form.title} onChange={handleChange} required />
            </label>

            <label>Description:
              <textarea name="description" value={form.description} onChange={handleChange} required />
            </label>

            <label>Current Price:
              <input type="text" name="price" value={form.price} onChange={handleChange} required />
            </label>

            <label>Original Price:
              <input type="text" name="originalPrice" value={form.originalPrice} onChange={handleChange} required />
            </label>

            <label>Discount Percent:
              <input type="text" name="discountPercent" value={form.discountPercent} onChange={handleChange} required />
            </label>

            <label>Image upload:
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImageFile(e.target.files[0])}
              />
            </label>

            <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
              <button type="submit">Submit Deal</button>
              <button type="button" onClick={() => setShowForm(false)}>Cancel</button>
            </div>

            {message && <p>{message}</p>}
          </form>
        </div>
      )}

      <div className="affiliate-grid">
        {(showAll ? deals : deals.slice(0, 6)).map((deal) => (
          <div key={deal._id} className="affiliate-card">
            <img src={deal.image} alt={deal.title} />
            <div className="affiliate-card-content">
              <h3>{deal.title}</h3>
              <p className="affiliate-description">{deal.description}</p>
              <p className="affiliate-price">
                <span className="current">{deal.price}</span>
                <span className="original">{deal.originalPrice}</span>
                <span className="discount">{deal.discountPercent} OFF</span>
              </p>
              <a
                href={deal.affiliate_link}
                target="_blank"
                rel="noopener noreferrer"
                className="affiliate-button"
              >
                Grab Deal
              </a>
            </div>
          </div>
        ))}
      </div>
      {!showAll && deals.length > 6 && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button className="add-deal-button" onClick={() => setShowAll(true)}>
            View More Deals
          </button>
        </div>
      )}
    </section>
  );
};

export default AffiliateDealsSection;